<template>
    <v-container class="pa-0 counter-header">
        <v-row no-gutters class="body-2 white--text" justify="center">
            <v-col class="flex-grow-0 flex-shrink-1 py-2 px-3">
                {{ stopTime }}
            </v-col>
            <v-col class="grow py-2 body-2 d-flex flex-row">
                <div class="me-auto">{{ stopName }}</div>
                <div v-if="bookingCount > 0">
                    <v-icon color="green-accent-2" size="22" icon="mdi-check-circle-outline" class="booking-icon"></v-icon>
                    <span class="booking-text">{{ `${bookingCount} ${bookingText}` }}</span>
                    <v-btn
                        v-if="noShow && editable"
                        density="comfortable"
                        icon="mdi-backspace-outline"
                        variant="plain"
                        @click="emit('delete-no-show')"
                    ></v-btn>
                    <v-btn
                        v-else-if="editable"
                        class="ml-3 text-none"
                        variant="outlined"
                        data-id="no-passengers-report"
                        @click="emit('no-passengers')"
                    >
                        Oppmøte
                    </v-btn>
                </div>
            </v-col>
            <v-col v-if="editable" class="flex-grow-0 flex-shrink-1 pa-2">
                <v-btn
                    variant="text"
                    flat
                    color="transparent"
                    class="counter-header__button"
                    data-id="toggle-counter-edit"
                    @click="toggleEditMode"
                >
                    <v-icon color="white" size="22">
                        {{ editMode ? 'mdi-gesture-tap' : 'mdi-square-edit-outline' }}
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { BookingNoShowType } from '../BookingNoShowModels';

const props = defineProps<{
    stopTime: string;
    stopName: string;
    editable: boolean;
    editMode: boolean;
    bookingCount: number;
    noShow?: BookingNoShowType;
    toggleEditMode: () => void;
}>();

const emit = defineEmits(['no-passengers', 'delete-no-show']);

const bookingText = computed(() => {
    switch (props.noShow) {
        case BookingNoShowType.NoTravellers:
            return 'bestillinger - Ingen reisende på kai';
        case BookingNoShowType.TooFewTravellers:
            return 'bestillinger - For få reisende på kai';
        default:
            return 'bestillinger';
    }
});
</script>

<style lang="scss" scoped>
.counter-header {
    background: rgb(var(--v-theme-primary));
    color: #ffffff;
    &__icon-wrapper {
        margin-left: auto;
    }

    &__button {
        position: relative;

        &::after {
            display: block;
            content: '';
            border-radius: 50%;
            position: absolute;
            height: 100px;
            width: 100px;
            top: -30px;
            left: -30px;
        }
    }
}

.booking-text {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
}

.booking-icon {
    padding-bottom: 1px;
}
</style>
